
import './js/old/slideToggle.min';
import filterSearch from './js/old/filterSearch';
import priceTabs from './js/old/priceTabs';
import './scss/old-acf-blocks/pricetabs.scss';

priceTabs();
filterSearch();
